<app-error-reporting
    [form]="form$ | async"
    [hasStarted]="hasStarted$ | async"
    [hasFinished]="hasFinished$ | async"
    (submit)="submit()"
  ></app-error-reporting>